<div class="card-wrapper">
  <h2 class="heading">{{ cardTitle }}</h2>

  <p class="excerpt">{{ cardExcerpt }}</p>

  <div class="content" [ngSwitch]="showId">
    <!-- Button -->
    <button
      type="button"
      (click)="showConfirmModel()"
      *ngSwitchCase="MakeAClaimEnum.BUTTON"
    >
      {{ cardButton?.button_text }}
    </button>

    <!-- Claims Number -->
    <a
      *ngSwitchCase="MakeAClaimEnum.CLAIM_NUMBER"
      [href]="'tel:' + cardClaimNumber"
      class="claims-number bold"
    >
      {{ cardClaimNumber }}
    </a>

    <div *ngSwitchCase="MakeAClaimEnum.NONE"></div>
  </div>
</div>

<app-modal [show]="showConfirm" (showChange)="confirmModalClosed()">
  <div class="confirm-changes-modal-content">
    <h2>Make a claim</h2>
    <p>
      {{
        !showNoConfirmation
          ? makeAClaimConfirmationText
          : makeAClaimNoConfirmationText
      }}
    </p>

    <div class="cta-wrapper" *ngIf="!showNoConfirmation">
      <button type="button" class="secondary" (click)="navigateNo()">No</button>
      <button type="button" class="secondary" (click)="navigateYes()">
        Yes
      </button>
    </div>
  </div>
</app-modal>
